import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const projectProofApi = generateProofApi('/proof-file/project');
const { getProofsOptions, getProofsByOwnerOptions, createOrUpdateProofOptions, deleteProofOptions } =
  generateProofOptions('project', projectProofApi);

export function getProjectProofsByOwnerOptions(projectId: Id, userId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsByOwnerOptions(projectId, userId);
}

export function getProjectProofsOptions(projectId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(projectId);
}

export function useUploadOrUpdateProjectProof(projectId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(projectId, queryClient));
}

export function useDeleteProjectProof(projectId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(projectId, queryClient));
}
